import React, { useState, useEffect, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { Row, Col, Container, Button } from "react-bootstrap";
import { IoMdOpen } from "react-icons/io";

import TaskMessages from "./TaskMessages";
import TaskHeader from "./TaskHeader";
import * as API from "../../api";
import * as CONST from "../../helpers/Constants";
import Loading from "../../shared/Loading";
import TaskAgents from "./TaskAgents";
import SaveTaskButtons from "./SaveTaskButtons";
import TaskOutcomes from "../forms/TaskOutcomes";
import GeneralPatientRequestForm from "../forms/GeneralPatientRequestForm";
import OldGeneralPatientRequestForm from "../forms/OldGeneralPatientRequestForm";
import InternalCommunicationForm from "../forms/InternalCommunicationForm";
import PatientRegistrationTask from "./PatientRegistrationTask";
import SpecialistReferralTask from "./SpecialistReferralTask";
import OrderRequestTask from "./OrderRequestTask";

import PatientCommunication from "../forms/PatientCommunicationForm";
import Cpr from "../task/cpr/Cpr";
import RxRequestForm from "../forms/RxRequestForm";
import DataEntry from "./DataEntry";
import Appointment from "./appointment/Appointment";

import { Settings, Task } from "../../helpers/Contexts";
import { AccessDenied } from "../../shared/AccessDenied";
import AbandonedCall from "./calls/AbandonedCall";
import VoicemailCall from "./calls/VoicemailCall";
import CurrentCall from "./calls/CurrentCall";
import CallItem from "./calls/CallItem";

const TaskItem = ({ state, dispatch }) => {
  let { id } = useParams();
  const settings = React.useContext(Settings);

  const [taskValues, setTaskValues] = useState({
    outcomes: {
      pcp_15min_response_completed: "",
      pcp_patient_30min_outreach_completed: "",
    },
    editing: {
      requested: false,
      scheduled: false,
      completed: false,
    },
    checked: {
      cpr: false,
      qm: false,
      conditions: false,
    },
  });

  const providerTaskValues = React.useMemo(
    () => ({ taskValues, setTaskValues }),
    [taskValues, setTaskValues]
  );

  const reloadTask = () => {
    dispatch({ type: "set_loading", payload: true });
    API.getTaskById(state.currentTask.id)
      .then((res) => {
        setTaskValues({
          ...taskValues,
          editing: { requested: false, scheduled: false, completed: false },
        });
        dispatch({ type: "set_current_task", payload: res });
      })
      .catch((err) => console.log(err));
  };

  const sendMessage = (req) => {
    API.postTaskMessage(req)
      .then((res) => reloadTask())
      .catch((err) => console.log(err));
  };

  const updateTaskHandler = (req) => {
    API.updateTask(state.currentTask.id, req)
      .then((res) => {
        reloadTask();
      })
      .catch((err) => console.log(err));
  };

  const saveTask = (status) => {
    !state.currentTask.pcp_15min_response_completed &&
      !state.currentTask.pcp_patient_30min_outreach_completed;
    return updateTaskHandler({
      task: {
        id: state.currentTask.id,
        ...taskValues.outcomes,
        priority: status == "closed" ? null : state.currentTask.priority,
        status: status,
      },
    });
  };
  useEffect(async () => {
    let idField = id || state.currentTask.id;
    dispatch({ type: "set_loading", payload: true });
    dispatch({ type: "set_settings_data", payload: await API.getSettings() });
    const task = await API.getTaskById(idField);
    task
      ? dispatch({ type: "set_current_task", payload: task })
      : dispatch({ type: "set_error", payload: true });
  }, []);

  const TaskActions = () => (
    <>
      <Col sm={4} lg={3} md={3} className="task-actions bg-grey br">
        <Button
          id="btn outline"
          className={taskValues.editing.requested && "show-cancel"}
          disabled={
            state.currentTask.status == "closed" || state.currentTask.task_type == "cpr_response"
              ? true
              : false
          }
          onClick={() => {
            !taskValues.editing.requested
              ? setTaskValues({
                  ...taskValues,
                  editing: { ...taskValues.editing, requested: true },
                })
              : setTaskValues({
                  ...taskValues,
                  editing: { ...taskValues.editing, requested: false },
                });
          }}
        >
          {taskValues.editing.requested && "Cancel"}
          {!taskValues.editing.requested && "Edit Task"}
        </Button>

        {state.currentTask.priority == "high" &&
          state.settings.me.support_agent_type == "Admin" && (
            <TaskOutcomes formHandler={(req) => updateTaskHandler(req)} task={state.currentTask} />
          )}
        {state.currentTask.cpr.sub_status == "closed-completed_results_obtained" &&
          state.settings.me.support_agent_type == "Admin" && (
            <DataEntry
              data={{
                patientPage: (
                  <>
                    <Link
                      to={{ pathname: state.currentTask.link }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      patient's record
                      <IoMdOpen id="document-icon" />
                    </Link>
                  </>
                ),
                cpr: state.currentTask.cpr,
                status: state.currentTask.status,
                type: state.currentTask.task_type,
              }}
            />
          )}
      </Col>
    </>
  );
  return (
    <>
      {state.isLoading && <Loading message={"loading..."} />}
      {!state.isLoading && !state.accessDenied && state.currentTask.cpr && (
        <Task.Provider value={providerTaskValues}>
          <Container className="task-item" id={state.currentTask.task_type}>
            <>
              <TaskHeader
                task={{
                  ...state.currentTask,
                  tags: state.currentTask.tags,
                  label: state.currentTask.label,
                  alert: state.currentTask.alert,
                  cprId: state.currentTask.cpr.id,
                  visitType: state.currentTask.visitType
                    ? state.currentTask.visitType
                    : state.currentTask.cpr.procedure_type
                    ? state.currentTask.cpr.procedure_type
                    : "",
                  priority: state.currentTask.priority,
                  status: state.currentTask.status,
                  id: state.currentTask.id,
                  link: state.currentTask.link,
                  agentNote: state.currentTask.agent_note,
                  agentNoteAddedBy: state.currentTask.agent_note_added_by,
                  agentNoteAddedOn: state.currentTask.agent_note_added_on,
                  waitingLabel: state.currentTask.waiting_label
                    ? state.currentTask.waiting_label.replaceAll("_", " ")
                    : "",
                }}
                formHandler={(req) => updateTaskHandler(req)}
                patient={{
                  ...state.patient,
                  url: state.currentTask.link,
                }}
                agents={
                  <TaskAgents
                    formHandler={(req) => updateTaskHandler(req)}
                    assigner={{
                      ...state.currentTask.assigner,
                      inSession: settings.me.id == state.currentTask.assigner.id ? true : false,
                    }}
                    data={{
                      assigner_support_group: state.currentTask.assigner_support_group,
                      assignee: state.currentTask.assignee,
                      assignee_support_group: state.currentTask.assignee_support_group,
                      id: state.currentTask.id,
                      task: state.currentTask,
                      inSession: settings.me.id == state.currentTask.assignee.id ? true : false,
                    }}
                  />
                }
                messages={
                  <>
                    <Col
                      md={
                        state.currentTask.phone_call && state.currentTask.phone_call.recording_url
                          ? 6
                          : 9
                      }
                      sm={
                        state.currentTask.phone_call && state.currentTask.phone_call.recording_url
                          ? 8
                          : 12
                      }
                      className={
                        state.currentTask.phone_call && state.currentTask.phone_call.recording_url
                          ? "no-gutters bt br task-messages-col"
                          : "no-gutters bt task-messages-col"
                      }
                    >
                      <TaskMessages
                        messages={state.currentTask.task_messages}
                        messageHandler={(req) => sendMessage(req)}
                        state={state}
                      />
                    </Col>
                    {state.currentTask.phone_call && state.currentTask.phone_call.recording_url && (
                      <CallItem task={state.currentTask} />
                    )}
                  </>
                }
              />
              <Row className="flex">
                <Col sm={12}>
                  {state.currentTask.task_type == "appointment_request" && (
                    <Appointment
                      task={{
                        ...state.currentTask,
                        patient: state.patient,
                        dispatch: dispatch,
                        formHandler: (req) => updateTaskHandler(req),
                      }}
                      children={
                        <>
                          {state.settings.me.support_agent_type == "Admin" && (
                            <Col className="pad20" md={5}>
                              <TaskOutcomes
                                formHandler={(req) => updateTaskHandler(req)}
                                task={state.currentTask}
                              />
                            </Col>
                          )}
                          {state.currentTask.cpr.sub_status &&
                            state.currentTask.cpr.sub_status ==
                              "closed-completed_results_obtained" && (
                              <Col className="" md={6}>
                                <DataEntry
                                  data={{
                                    patientPage: (
                                      <>
                                        <Link
                                          to={{ pathname: state.currentTask.link }}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          patient's record
                                          <IoMdOpen id="document-icon" />
                                        </Link>
                                      </>
                                    ),
                                    cpr: state.currentTask.cpr,
                                    status: state.currentTask.status,
                                    type: state.currentTask.task_type,
                                  }}
                                />
                              </Col>
                            )}
                        </>
                      }
                    />
                  )}

                  {(CONST.CPR_TASK_TYPES.includes(state.currentTask.task_type) == true ||
                    (state.currentTask.task_type == "patient_communication" &&
                      state.currentTask.cpr &&
                      state.currentTask.cpr.id)) && (
                    <Cpr
                      task={{
                        ...state.currentTask,
                        patient: state.patient,
                        dispatch: dispatch,
                        reloadTask: reloadTask,
                        formHandler: (req) => updateTaskHandler(req),
                      }}
                      children={
                        state.currentTask.cpr.sub_status &&
                        state.currentTask.cpr.sub_status == "closed-completed_results_obtained" && (
                          <DataEntry
                            data={{
                              patientPage: (
                                <>
                                  <Link
                                    to={{ pathname: state.currentTask.link }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    patient's record
                                    <IoMdOpen id="document-icon" />
                                  </Link>
                                </>
                              ),
                              cpr: state.currentTask.cpr,
                              status: state.currentTask.status,
                              type: state.currentTask.task_type,
                            }}
                          />
                        )
                      }
                    />
                  )}
                  {state.currentTask.task_type == "general_patient_request" && state.settings.referral_request_v2_enabled == true && (
                    <GeneralPatientRequestForm
                      dispatch={dispatch}
                      state={state}
                      task={{
                        ...state.currentTask,
                        isNew: false,
                        formHandler: (req) => updateTaskHandler(req),
                        actions: <TaskActions />,
                      }}
                    />
                  )}

                  {state.currentTask.task_type == "general_patient_request" && state.settings.referral_request_v2_enabled == false && (
                    <OldGeneralPatientRequestForm
                      dispatch={dispatch}
                      state={state}
                      task={{
                        ...state.currentTask,
                        isNew: false,
                        formHandler: (req) => updateTaskHandler(req),
                        actions: <TaskActions />,
                      }}
                    />
                  )}

                  {state.currentTask.task_type == "patient_self_registration" && (
                    <PatientRegistrationTask
                      task={{
                        ...state.currentTask,
                        isNew: false,
                        formHandler: (req) => updateTaskHandler(req),
                        actions: <TaskActions />,
                      }}
                    />
                  )}

                  {state.currentTask.task_type == "order_request" && (
                    <OrderRequestTask
                      task={{
                        ...state.currentTask,
                        isNew: false,
                        formHandler: (req) => updateTaskHandler(req),
                        actions: <TaskActions />,
                      }}
                    />
                  )}


                  {state.currentTask.task_type == "specialist_referral" && (
                    <SpecialistReferralTask
                      task={{
                        state: state,
                        ...state.currentTask,
                        isNew: false,
                        formHandler: (req) => updateTaskHandler(req),
                        actions: <TaskActions />,
                      }}
                    />
                  )}

                  {state.currentTask.task_type == "internal_communication" && (
                    <InternalCommunicationForm
                      task={{
                        ...state.currentTask,
                        isNew: false,
                        formHandler: (req) => updateTaskHandler(req),
                        actions: <TaskActions />,
                      }}
                    />
                  )}
                  {state.currentTask.task_type == "rx_request" && (
                    <RxRequestForm
                      task={{
                        ...state.currentTask,
                        formHandler: (req) => updateTaskHandler(req),
                        actions: <TaskActions />,
                      }}
                    />
                  )}
                  {state.currentTask.task_type == "abandoned_calls" && (
                    <AbandonedCall
                      task={{
                        ...state.currentTask,
                        formHandler: (req) => updateTaskHandler(req),
                        actions: <TaskActions />,
                      }}
                    />
                  )}
                  {state.currentTask.task_type == "voicemail_calls" && (
                    <VoicemailCall
                      task={{
                        ...state.currentTask,
                        formHandler: (req) => updateTaskHandler(req),
                        actions: <TaskActions />,
                      }}
                    />
                  )}
                  {state.currentTask.task_type == "external_communication" && (
                    <PatientCommunication
                      task={{
                        ...state.currentTask,
                        formHandler: (req) => updateTaskHandler(req),
                        actions: <TaskActions />,
                      }}
                    />
                  )}

                  {(state.currentTask.task_type == "inbound_calls" ||
                    state.currentTask.task_type == "outbound_calls") && (
                    <CurrentCall
                      dispatch={dispatch}
                      state={state}
                      task={{
                        ...state.currentTask,
                        formHandler: (req) => updateTaskHandler(req),
                        actions: <TaskActions />,
                      }}
                    />
                  )}
                </Col>
              </Row>
              <SaveTaskButtons
                saveTask={(params) => saveTask(params)}
                data={{
                  status: state.currentTask.status,
                  taskType: state.currentTask.task_type,
                  cpr: state.currentTask.cpr.sub_status ? state.currentTask.cpr.sub_status : "",
                }}
              />
              <div>
                Created At: <b>{state.currentTask.created_at}</b>
              </div>
            </>
          </Container>
        </Task.Provider>
      )}
      {!state.isLoading && state.accessDenied && <AccessDenied />}
    </>
  );
};

export default TaskItem;
